import { Grid } from '@mui/material'
import { CustomInput } from 'src/consumer/components/helperComponents'
import { getNumberStringForInput } from 'src/mentor/helpers/utilityFunctions'
import PrescriptionSectionCard from './PrescriptionSectionCard'

/**
 * Section for sidebar width configuration
 * Handles both left and right sidebar widths
 */
export default function SidebarDetailsSection({
  prescriptionTemplate,
  handleChangeLeftSidebar,
  handleChangeRightSidebar,
  disabled,
}) {
  return (
    <>
      <PrescriptionSectionCard heading="Left sidebar">
        <Grid item xs={12} md={12}>
          <CustomInput
            id="width"
            label="Custom left width (inches)"
            type="number"
            value={prescriptionTemplate?.leftSidebar?.width}
            onChange={handleChangeLeftSidebar}
            disabled={disabled}
          />
        </Grid>
      </PrescriptionSectionCard>

      <PrescriptionSectionCard heading="Right sidebar">
        <Grid item xs={12} md={12}>
          <CustomInput
            id="width"
            label="Custom right sidebar width (inches)"
            type="number"
            value={getNumberStringForInput(prescriptionTemplate?.rightSidebar?.width)}
            onChange={handleChangeRightSidebar}
            disabled={disabled}
          />
        </Grid>
      </PrescriptionSectionCard>
    </>
  )
}
